import React from 'react';
import { PostList } from '../../../Containers';
import Constants from '../../../Config/Constants';

const PostScreenComponent = props => {
  return <PostList postType={Constants.POST_TYPE.PROFILE} {...props} />;
};

export default PostScreenComponent;
